import {
  ClipboardList,
  Users,
  FileText,
  AlertTriangle,
  MessageSquare,
} from "lucide-react";

const allTabs = [
  { id: "applications", icon: ClipboardList, label: "Applications", labelKn: "ಅರ್ಜಿಗಳು", superOnly: false, gokHide: false },
  { id: "officials", icon: Users, label: "Officials", labelKn: "ಅಧಿಕಾರಿಗಳು", superOnly: true, gokHide: false },
  { id: "applications-management", icon: FileText, label: "Manage", labelKn: "ನಿರ್ವಹಣೆ", superOnly: true, gokHide: false },
  { id: "messaging", icon: MessageSquare, label: "Messages", labelKn: "ಸಂದೇಶ", superOnly: true, gokHide: true },
  { id: "sla-violations", icon: AlertTriangle, label: "SLA", labelKn: "SLA", superOnly: false, gokHide: true },
];

export default function MobileOfficialTabs({ activeTab, onTabChange, isSuperAuthority, isGOKOfficial }) {
  const visibleTabs = allTabs.filter((tab) => {
    if (tab.superOnly && !isSuperAuthority) return false;
    if (tab.gokHide && isGOKOfficial) return false;
    return true;
  });

  const handleClick = (tab) => {
    onTabChange(tab.id);
  };

  return (
    <nav
      data-testid="mobile-official-tabs"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone-200 shadow-[0_-2px_10px_rgba(0,0,0,0.08)] md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex items-center overflow-x-auto scrollbar-hide h-14">
        {visibleTabs.map((tab) => {
          const Icon = tab.icon;
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => handleClick(tab)}
              data-testid={`mobile-tab-${tab.id}`}
              className={`flex flex-col items-center justify-center min-w-[64px] flex-shrink-0 flex-1 h-full transition-colors relative ${
                active
                  ? "text-emerald-700"
                  : "text-stone-400 active:text-emerald-600"
              }`}
            >
              {active && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-emerald-600 rounded-b" />
              )}
              <Icon className={`w-[18px] h-[18px] ${active ? "stroke-[2.5]" : ""}`} />
              <span className={`text-[9px] mt-0.5 leading-tight ${active ? "font-bold" : "font-medium"}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
